var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 30,
    viewBox: "0 0 23 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5697 6.92347C20.0104 3.20648 17.1303 0.947725 13.1479 0.202442C10.785 -0.270075 8.33149 0.0904256 6.20446 1.22265C2.27319 3.29408 0.248933 6.60137 0.00499756 10.3628C-0.0623879 13.2604 0.552168 15.5353 1.81901 17.3709C3.82036 20.2658 5.86214 23.127 7.89583 25.9963C8.72332 27.1674 9.54947 28.3413 10.3837 29.5003C10.8554 30.1607 11.5778 30.1607 12.0562 29.5111C12.0966 29.4572 12.1344 29.4019 12.1735 29.3467C14.8689 25.5326 17.5845 21.7267 20.2705 17.9032C22.6748 14.4895 23.1829 10.7725 21.5697 6.92347ZM11.1923 15.0097C10.2008 14.9938 9.25508 14.5897 8.55831 13.8841C7.86153 13.1785 7.46932 12.2278 7.46591 11.2361C7.47973 10.2445 7.88339 9.29808 8.58958 8.60172C9.29578 7.90536 10.2477 7.51502 11.2395 7.51511C11.7313 7.51812 12.2178 7.61797 12.671 7.80897C13.1243 7.99997 13.5354 8.27836 13.8811 8.62827C14.2268 8.97818 14.5001 9.39275 14.6855 9.8483C14.871 10.3039 14.9649 10.7915 14.9619 11.2833C14.9589 11.7751 14.859 12.2616 14.668 12.7148C14.477 13.1681 14.1986 13.5793 13.8487 13.9249C13.4988 14.2706 13.0842 14.5439 12.6287 14.7294C12.1731 14.9148 11.6855 15.0087 11.1937 15.0057L11.1923 15.0097Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.78c28f2287a8b81e7f5473f2ee523c05.svg";
export { ForwardRef as ReactComponent };